export const AlaricFundPortalId = 4;
export const AlaricFundPortalAccountIdentifier = 'AAA';
export const TenEnPortalId = 5;
export const TenEnPortalAccountIdentifier = 'TNN';
export const HammerWebPortalAccountIdentifier = 'HWL';
export const DemoAlaricProPortalAccountIdentifier = 'DMO';